import styled from 'styled-components';

export const Table = styled.table`
  width: 100%;
  border-radius: 10px;
  background: none;
  border: 1px solid #efefef;
  padding: 3px;
  margin: 0;
  box-sizing: border-box;
  transition: all 0.5s ease-in-out;
  border-collapse: collapse;
  border-spacing: 0;
`;

export const TableHead = styled.thead`
  border-radius: 10px 10px 0 0;
  padding: 0;
  margin: 0;
  background: #f1fff2;
`;

export const TableRowHead = styled.tr`
  background: none;
  background: none;
  border-radius: 10px;
  padding: 0;
  margin: 0;
`;

export const TableCellHead = styled.td`
  background: none;
  font-weight: 500;
  color: #1e1e1e;
  border-bottom: 1px solid #efefef;
  border-right: 1px solid #efefef;
  border-left: 1px solid #efefef;

  padding: 20px;
  font-size: 18px;
  &:first-child {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }

  &:last-child {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
  cursor: pointer;
  &:nth-child(even) > td {
    background: #fafafa;
  }
  &:nth-child(odd) > td {
    background: #fff;
  }
  &:hover {
    transition: all 0.3s ease-in-out;

    box-shadow: 0 10px 30px #0d86ff3b, 0 10px 30px #44d78961;
    z-index: 2;

    & > td {
      background: #f1fff2;
    }
  }
`;

export const TableCell = styled.td`
  background: none;
  padding: 15px;
  font-size: 16px;

  border-right: 1px solid #efefef;
  border-left: 1px solid #efefef;

  &:first-child {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }

  &:last-child {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }
`;
